/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('util/eventhandler',['util/list'],
function (List) {
    var EventHandler = function () {
        this.initEventHandler();
    };

    EventHandler.constructor = EventHandler;
    EventHandler.prototype = Object.create(List.prototype);

    EventHandler.prototype.initEventHandler = function () {
        List.call(this);
    };

    EventHandler.prototype.handleEvent = function (sender, args) {
        for (var i = 0; i < this.items.length; i++) {
            var callback = this.items[i];
            if (typeof callback == 'function') {
                callback(sender, args);
            }
        }
    };

    EventHandler.prototype.add = function(item) {
        List.prototype.add.call(this, item);
    };

    return EventHandler;

});

